import { Controller, useFormContext } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import DropdownStyled from '../../../components/inputs/StyledInputs/DropdownStyled';
import { CompanySource } from '../../../Interfaces/admin/User.interfaces';

export type CompanyStatusFilter = 'active' | 'inactive' | 'both';

export type CompaniesFilterArgs = {
  source?: CompanySource;
  info?: string;
  status?: CompanyStatusFilter;
};

const statusOptions: { label: string; value: CompanyStatusFilter }[] = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  { label: 'Both', value: 'both' },
];

const CompaniesFilter = () => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-wrap justify-content-center align-items-end md:justify-content-start gap-4 form">
      <div className="w-15rem">
        <div className="text-standard mb-2">Source</div>
        <Controller
          control={control}
          name="source"
          render={({ field: { onChange, ...otherFields } }) => (
            <DropdownStyled
              options={Object.values(CompanySource)}
              clearable={true}
              placeholder="Select Source"
              onChange={(e) => {
                onChange(e);
              }}
              {...otherFields}
            />
          )}
        />
      </div>
      <div className="w-15rem">
        <div className="text-standard mb-2">Status</div>
        <Controller
          control={control}
          name="status"
          render={({ field: { onChange, ...otherFields } }) => (
            <DropdownStyled
              options={statusOptions}
              labelField="label"
              valueField="value"
              clearable={false}
              placeholder="Select Status"
              onChange={(e) => {
                onChange(e);
              }}
              {...otherFields}
            />
          )}
        />
      </div>
      <div className="w-15rem align-self-end">
        <Controller
          control={control}
          name="info"
          defaultValue=""
          render={({ field }) => (
            <span className="p-input-icon-right">
              <InputText
                type="text"
                placeholder="Search"
                className="fieldBorder w-full text-standard blackText"
                {...field}
              />
              <i className="pi pi-search" />
            </span>
          )}
        />
      </div>
    </div>
  );
};

export default CompaniesFilter;
